import Stack from '@mui/material/Stack';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import {blue } from '@material-ui/core/colors/';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import products from '../../data/computer'


const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[500],
  '&:hover': {
    backgroundColor: blue[800],
  },
}));

export default function CustomizedButtons() {
  
  return (
    <Stack spacing={2} direction="row">
      <ColorButton
        style={{ minWidth: '65%', minHeight: '3.125rem' }}
        startIcon={<ComputerOutlinedIcon></ComputerOutlinedIcon>}
        size="larger"variant="contained">Meus Hardwares: {products.length}
      </ColorButton>
    </Stack>
  );
}